import { IClauseChecklistList } from "@/api";
import { UserChip } from "@/components/shared/chips/UserChip";
import { SharedWithGroupLabel } from "@/components/shared/SharedWithGroupLabel";
import { formatDate } from "@/utils";
import { Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";

interface IProps {
    /**
     * The clause checklist to display.
     */
    clauseChecklist: IClauseChecklistList;
}

/**
 * Displays a card for a clause checklist.
 */
export const ClauseChecklistCard = ({ clauseChecklist }: IProps) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(`/organizations/checklists/${clauseChecklist.id}`);
    };

    return (
        <div onClick={handleCardClick} style={{ cursor: "pointer" }}>
            <Paper
                variant="outlined"
                sx={{
                    height: "100%",
                    minHeight: 240,
                    "&:hover": {
                        bgcolor: "action.hover",
                    },
                }}
            >
                <Stack p={2} gap={2}>
                    <Stack minWidth={0}>
                        <Typography
                            variant="h6"
                            color="primary"
                            fontWeight={500}
                        >
                            {clauseChecklist.name}
                        </Typography>
                        <SharedWithGroupLabel
                            group={clauseChecklist.organization_group}
                        />
                    </Stack>
                    <Stack gap={2}>
                        <Typography
                            variant="body2"
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "3",
                                WebkitBoxOrient: "vertical",
                            }}
                        >
                            {clauseChecklist.description}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            fontWeight={500}
                        >
                            Last updated:{" "}
                            {formatDate(clauseChecklist.updated_at, "PP")}
                        </Typography>
                    </Stack>

                    <div>
                        <UserChip insureScope size="small" />
                    </div>
                </Stack>
            </Paper>
        </div>
    );
};
